import {
  AUTO_DISCONNECT_TIMEOUT,
  AUTO_DISCONNECT_TIMEOUT_WHEN_MOD_LEAVE
} from "../constants"
import { UserType } from "../constants/enums"
import { ConsoleLogger } from "./logger"
import MOLocation from "./MOLocation"

const logger = new ConsoleLogger()

let previousAudienceCount = 0
let isModOrBroadWasPresent = false
let audienceDisconnectTimerId = null

/**
 * 60 min timer when all m and b leave a room and to start a 120 min timer when an a joins an empty room
 */

const restartAudienceDisconnectTimer = () => {
  stopAudienceDisconnectTimer()
  audienceDisconnectTimerId = setTimeout(
    () => {
      MOLocation.reload()
    },
    isModOrBroadWasPresent
      ? AUTO_DISCONNECT_TIMEOUT_WHEN_MOD_LEAVE
      : AUTO_DISCONNECT_TIMEOUT
  )
  logger.log(
    "Start autoDisconnectAudience timer, Id: ",
    audienceDisconnectTimerId
  )
}

export const startAudienceDisconnectTimer = ({
  audienceCount,
  broadcasterCount,
  moderatorCount
}) => {
  const isModOrBroadPresent = moderatorCount || broadcasterCount
  const isAudienceRemoved = audienceCount < previousAudienceCount
  const isAudience =
    window.MeetOnline.client()?.user?.type === UserType.AUDIENCE
  const isAudienceAdded = audienceCount > previousAudienceCount
  previousAudienceCount = audienceCount

  if (isModOrBroadPresent && !isModOrBroadWasPresent) {
    isModOrBroadWasPresent = true
  }

  // If not audience or audience leaved : don't do anything
  if (!isAudience || isAudienceRemoved) return

  if (isModOrBroadPresent) {
    stopAudienceDisconnectTimer()
    return
  }

  if (!audienceDisconnectTimerId) {
    // start timer if mod is not present
    return restartAudienceDisconnectTimer()
  }

  if (isAudienceAdded) {
    // restart the timer when audience is added
    return restartAudienceDisconnectTimer()
  }
}

export const stopAudienceDisconnectTimer = (resetAllValue: boolean = false) => {
  if (audienceDisconnectTimerId) {
    logger.log(
      "Stop autoDisconnectAudience timer, Id: ",
      audienceDisconnectTimerId
    )
    clearTimeout(audienceDisconnectTimerId)
    audienceDisconnectTimerId = null
  }
  if (resetAllValue) {
    previousAudienceCount = 0
    isModOrBroadWasPresent = false
    audienceDisconnectTimerId = null
  }
}
